import { DateRangeType } from '../../common/components/DateRangeTypePicker';

export type EVSECerts = {
  clientP12Base64: string;
  p12Password: string;
  serverCABase64: string;
};

export type EVSEToken = {
  token: string;
};

export type WifiData = {
  ssid: string;
  password: string;
};

export type WifiListNetwork = {
  signalStrength: number;
  ssid: string;
};

export type QRCodeValues = { sn: string; cpid: string; wifi: WifiData | null };

export type ChargerConfiguration = {
  imgSrc: {
    light: string;
    dark: string;
  };
};

export type Schedule = {
  groupId: string | null;
  name: string | null;
  daysOfWeek: number[];
  startTime: string | null;
  endTime: string | null;
  isEditing: boolean;
};

export const AggregationType = {
  ...DateRangeType,
  Session: 'SESSION',
} as const;

export type AggregationType = (typeof AggregationType)[keyof typeof AggregationType];

export type ChargingActivityData = {
  totalCost: string;
  totalChargeTime: string;
  totalEnergyConsumed: string;
  savings: number;
  chargingSessions: ChargingActivitySessionData[];
};

export type ChargingActivitySessionData = {
  id: number;
  weeks?: number;
  start: string;
  end: string;
  cost: number;
  usage: number;
  records: ChargingActivityRecordsRawData[];
};

export type ChargingActivityRawData = {
  agg_type: AggregationType;
  total_energy: number;
  total_charge_count: number;
  total_charge_duration: number;
  total_cost: number;
  smart_control_savings: number;
  records: ChargingActivityRecordsRawData[];
};

export type ChargingActivityRecordsRawData = {
  charge_count?: number;
  start: string;
  end: string;
  usage: number;
  total_cost?: number;
  cost?: number;
  records?: ChargingActivityRecordsRawData[];
};
